export default "__VITE_ASSET__gn8aLuUe__"